import { MINUTOS_SEM_GPS } from "../../util/freight/acompanhamento-marcacoes";

/** ~66 m. Duas paradas vizinhas dentro disso são a mesma parada partida na fronteira da página. */
const RAIO_DE_FUSAO = 6e-4;

function mesmoLugar(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    Math.abs(a[0] - b[0]) < 1e-6 &&
    Math.abs(a[1] - b[1]) < 1e-6
  );
}

/**
 * O resumo vem por página, então uma parada que começa no fim de uma e termina no começo da outra
 * volta partida em duas. Só paradas vizinhas se fundem, e só dentro do raio.
 */
export function fundirParadas(paradas) {
  const fundidas = [];
  for (const parada of paradas) {
    const anterior = fundidas[fundidas.length - 1];
    if (
      anterior &&
      Math.abs(anterior.latitude - parada.latitude) < RAIO_DE_FUSAO &&
      Math.abs(anterior.longitude - parada.longitude) < RAIO_DE_FUSAO
    ) {
      anterior.fimMs = parada.fimMs;
      anterior.minutos = Math.round(
        (anterior.fimMs - anterior.inicioMs) / 60000,
      );
      anterior.pontos += parada.pontos;
      continue;
    }
    fundidas.push({ ...parada });
  }
  return fundidas;
}

/**
 * Junta as partes do trajeto — as páginas da carga e a cauda que a atualização troca — no que o mapa
 * desenha, em ordem de tempo.
 *
 * Não muta as partes. A cauda é trocada inteira a cada consulta, e a emenda antiga fazia `push` no
 * trecho da página anterior: trocar a cauda deixaria nele um pedaço da cauda velha.
 *
 * O buraco na virada é medido como o servidor mede dentro da página, em minutos arredondados. Com a
 * conta crua, 45,2 min viravam lacuna aqui e não lá, e a mesma viagem desenhava diferente conforme
 * caísse a fronteira.
 */
export function costurar(partes) {
  const juntas = { trechos: [], paradas: [], lacunas: [], operacionais: [] };
  let anterior = null;

  for (const parte of partes) {
    if (!parte || parte.primeiroMs == null) continue;

    const trechos = (parte.trechos || []).map((trecho) => [...trecho]);
    if (anterior) {
      const minutos = Math.round((parte.primeiroMs - anterior.ultimoMs) / 60000);
      const ultimo = juntas.trechos[juntas.trechos.length - 1];

      if (minutos > MINUTOS_SEM_GPS) {
        juntas.lacunas.push({
          deMs: anterior.ultimoMs,
          ateMs: parte.primeiroMs,
          minutos,
          // As pontas cruas quando o backend manda; no formato antigo, a coordenada do trecho.
          de: anterior.ultimaCoordenada || ultimo?.[ultimo.length - 1],
          ate: parte.primeiraCoordenada || trechos[0]?.[0],
        });
      } else if (ultimo && trechos.length) {
        // Sem buraco, o primeiro trecho da parte continua o último: são duas metades da mesma linha,
        // cortadas só porque a fronteira caiu ali. O ponto da emenda não se repete.
        const emenda = trechos.shift();
        ultimo.push(
          ...(mesmoLugar(ultimo[ultimo.length - 1], emenda[0])
            ? emenda.slice(1)
            : emenda),
        );
      }
    }

    juntas.trechos.push(...trechos);
    juntas.paradas.push(...(parte.paradas || []));
    juntas.lacunas.push(...(parte.lacunas || []));
    juntas.operacionais.push(...(parte.operacionais || []));
    anterior = parte;
  }

  return { ...juntas, paradas: fundirParadas(juntas.paradas) };
}
